import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
/**
 * Renders an Accordion list on page.
 *
 * @component
 *
 * return (
 *   <AccordionDefault data={obj}/>
 * );
 */

const AccordionDefault = ({ data }) => {
  return (
    <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
      {data.map(item => (
        <AccordionItem key={item.titulo}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <h3>{item.titulo}</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div
              className="resposta"
              dangerouslySetInnerHTML={{ __html: item.conteudo }}
            />
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  )
}

export default AccordionDefault
